export const SUMMARY_TITLE_DEFINITION_URL = "http://hl7.org/fhir/StructureDefinition/summaryTitle"
export const REQUIRED_ERROR_DEFINITION_URL = "http://hl7.org/fhir/StructureDefinition/requiredError"
export const HIDE_ON_VALUE_DEFINITION_URL = "http://hl7.org/fhir/StructureDefinition/hideOn"
